
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { LogListApi } from '@/api/order'
import { getStoreOrderOperateLog } from '@/api/industryMall'

@Component({
  name: 'LogPopup'
})
export default class LogPopup extends Vue {
  @Getter companyId!: string
  showOrderLog = false
  params = {
    isReturn: true, // 是否是退货单 Boolean
    storeId: "",
    // currRouteId: '',
    orderId: "",
    isValid: "Y",
  }
  logList: LogListApi[] = []

  showPopup(orderInfo: any, isReturn: string) {
    this.showOrderLog = true
    this.params.storeId = orderInfo.storeId as string
    this.params.orderId = orderInfo.orderId as string
    this.params.isReturn = isReturn === '1'
    this.getNodeList()
  }

  getNodeList() {
    getStoreOrderOperateLog(this.params).then((res) => {
      this.logList = res.data || []
    })
  }
}
